module.exports = __webpack_public_path__ + "static/media/metal_progetti_icon.3b168d4e.svg";